import { ref, onMounted, onBeforeUnmount, computed } from "vue";
import throttle from 'lodash/throttle';

const devicePoints = {
  phone: [320, 480],
  pad: [481, 768],
  notebook: [769, 1024],
  desktop: [1025, 1200],
  tv: 1201,
};

/**
 * 监听 window.resize 事件，返回设备类型
 * @param {*} wait 节流延迟时间
 * @returns 
 */
function useRespondTo(wait = 30) {

  const device = ref();

  const resizeListener = () => {
    const innerWidth = window.innerWidth;
    const {
      phone,
      pad,
      notebook,
      desktop,
      tv,
    } = devicePoints;
    if (innerWidth <= phone[1]) {
      device.value = 'phone';
    } else if (innerWidth >= pad[0] && innerWidth <= pad[1]) {
      device.value = 'pad';
    } else if (innerWidth >= notebook[0] && innerWidth <= notebook[1]) {
      device.value = 'notebook';
    } else if (innerWidth >= desktop[0] && innerWidth <= desktop[1]) {
      device.value = 'desktop';
    } else if (innerWidth >= tv) {
      device.value = 'tv';
    }
  };
  
  resizeListener();

  const attachResizeListener = () => {
    window.addEventListener('resize', throttle(resizeListener, wait));
  };

  const detachResizeListener = () => {
    window.removeEventListener('resize', resizeListener);
  };

  onMounted(() => {
    attachResizeListener();
  });

  onBeforeUnmount(() => {
    detachResizeListener();
  });

  // 小于 1200 都算移动设备
  const isMobile = computed(() =>
    device.value === 'phone'
    || device.value === 'pad'
    || device.value === 'notebook'
    || device.value === 'desktop'
  );

  return {
    device,
    isMobile,
  };
}

export default useRespondTo;
